var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    class: [
      `wishlist-icon wishlist-icon--${_vm.colour}`,
      _vm.brandName === _vm.Brand.Travelsphere ? "wishlist-iconTs" : "",
      _vm.wishlistState ? "wishlist-icon--added" : "",
    ],
    on: {
      click: function ($event) {
        _vm.wishlistState = !_vm.wishlistState
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }